import { Table, TableBody, TableHead } from '@mui/material'
import { Herd } from 'models/IFarm'
import CustomTableRow from 'ui/table/CustomTableRow'
import { TableHeader } from './components'
import { useGetCellOptions } from './hooks/useGetCellOptions'

interface LargeHerdStructureWidgetTableProps {
	herd: Herd
}
export const LargeHerdStructureWidgetTable = ({
	herd,
}: LargeHerdStructureWidgetTableProps) => {
	const TABLE_OPTIONS = useGetCellOptions({ herd })
	return (
		<Table>
			<TableHead>
				<TableHeader />
			</TableHead>
			<TableBody>
				{TABLE_OPTIONS.map((option, index) => (
					<CustomTableRow
						key={index}
						rowKey={option.rowKey}
						cellItems={option.cellItems}
						rowHeight={option.rowHeight}
					/>
				))}
			</TableBody>
		</Table>
	)
}
